export default {
  home: 'NEXT',
  notifications: 'Notificaciones',
  schedule: 'Horario',
  openShifts: 'NEXT Shifts',
  chat: 'Chat',
  myShifts: 'Mis Turnos',
  announcements: 'News',
  dm: 'Mensajes Directos',
  marked: 'Marcados',
  markedMessages: 'Mensajes Marcados',
  sentMessages: 'Mensajes Enviados',
  sent: 'Enviados',
  groups: 'Grupos',
  messages: 'Mensages',
  tools: 'Herramientas',
  verify: 'Verificar',
  verifyPhone: 'Ingrese el número de teléfono',
  activate: 'Activar,',
  settings: 'Ajustes',
  pendingApproval: 'Aprobación Pendiente',
  markAllRead: 'Marcar Todo Como Leído',
  shift: 'Turno',
  startDate: 'Fecha de inicio',
  endDate: 'Fecha final',
  holidays: 'Vacaciones',
  timeOff: 'Tiempo Libre',
  timeOffRequest: 'Solicitud de tiempo libre',
  timeOffRequests: {
    zero: 'Sin solicitudes de tiempo libre',
    one: '1 Solicitud de tiempo libre',
    other: '%{count} solicitudes de tiempo libre',
  },
  noNewTimeOffRequests: 'No hay nuevas solicitudes de tiempo libre',
  requestTimeOff: 'Solicitar tiempo libre',
  editTimeOff: 'Editar solicitud de tiempo libre',
  addReasonForTimeOff: 'Agregar motivo para el tiempo libre (Obligatorio)',
  approvedTimeOff: 'Tiempo libre aprobado',
  rejectedTimeOff: 'Tiempo libre rechazado',
  requestedTimeOff: 'Tiempo libre solicitado',
  timeOffRequestList: 'Solicitudes de tiempo libre',
  editTimeOffRequest: 'Editar solicitud de tiempo libre',
  updateRequest: 'Solicitud de actualización',
  sendRequest: 'Enviar solicitud',
  allDay: 'Todo el día',
  days: {
    // zero: 'No Time Off Requests',
    one: '1 Día',
    other: '{{count}} Días',
  },
  day: 'Día',
  week: 'Semana',
  working: 'Laborable',
  approvedBy: 'Aprobado por',
  user: 'Usuario',
  account: 'Cuenta',
  selectValue: 'Selecciona Valor',
  calendars: 'Calendario',
  editShift: 'Editar Turno',
  anyPosition: 'Cualquier Posición',
  helper: 'Empleado',
  manager: 'Gerente',
  observer: 'Observador',
  chooseRole: 'Elegir Rol',
  unreadNotifications: 'Notificaciones no leídas',
  openShiftsAvailable: 'Turnos Disponibles de NEXT',
  done: 'Finalizar',
  next: 'Siguiente',
  cancel: 'Cancelar',
  create: 'Crear',
  stores: 'Tiendas',
  store: 'Tienda',
  helperSchedule: 'Mis Turnos',
  storeSchedule: 'Horario de la Tienda',
  chatNotAvailable: 'Chat no disponible ',
  signingOut: 'Cerrando Sesión...',
  seeMore: 'Ver mas %d',
  andMore: 'y {{count}} más',
  noNew: 'No nuevo',
  storeOpenShifts: 'NEXT Shifts',
  loggedInAs: 'Conectado como',
  editMyProfile: 'Editar Ferfil',
  editUsername: 'Editar su Nombre y Foto',
  uploadPhoto: 'Toca para subir una foto',
  avatarDesc:
    'Agrega una foto para que tus gerentes y compañeros de trabajo te reconozcan',
  signOut: 'Finalizar Sesión',
  privacyPolicy: 'Política de Privacidad',
  termsOfUse: 'Términos y Condiciones',
  crewList: 'Mi Equipo',
  enter: 'Entrar',
  selected: 'Seleccionado',
  from: 'De',
  to: 'A',
  profile: 'Perfil',
  addMobileNumber: 'Agregar Número de teléfono Móvil',
  addMobileNumberErrorTitle: 'No se pudo agregar el número de móvil',
  enterMobileNumberHere: 'Entrar número de teléfono móvil aqui',
  addMobileNumberText:
    'Agregar número móvil para {USER_NAME}. Asegúrate que sea número móvil y no teléfono fijo.',
  seeAll: 'Ver todo >',
  confirmShiftAction: 'Confirmación',
  requestHelp: 'Solicitar Ayuda',
  confirmEdit: 'Confirmar Corrección',
  addShift: 'Agregar Turno',
  noOpenShifts: 'No turnos NEXT disponibles.',
  confirmMarkAll: 'Marcar todos como leídos?',
  confirmSendAttachment: 'Enviar archivo ?',
  noShifts: 'No hay turnos',
  makeChanges: 'Hacer Cambios',
  groupMessages: 'Mensajes de Grupo',
  directMessages: 'Mensajes directos',
  noDirectMessages: 'No hay mensajes directos',
  deleteOwn: 'Eliminar',
  deleteOthers: 'Eliminar',
  showReadersOwn: 'Leído por…',
  showReadersOthers: 'Leído por…',
  pinMessage: 'Alfiler',
  unpinMessage: 'Desprender',
  mark: 'Marca',
  unmark: 'Desmarcar',
  mention: 'Mención',
  mentions: 'Menciona',
  makeGroupAdmin: 'Hacer administrador de grupo',
  removeGroupAdmin: 'Descartar como administrador',
  admin: 'Admin',
  directMessagePrompt:
    'Mantén presionado cualquier mensaje para responder con un mensaje directo.',
  updateMessage:
    'Hay una nueva actualización disponible. La aplicación se actualizará la próxima vez que la reinicie.',
  updateAvailable: 'Actualización disponible',
  newAppVersion:
    'Hay disponible una versión más reciente de esta aplicación. Toque aquí para actualizar.',
  addMembers: 'Añadir Miembros',
  newGroup: 'Nuevo Grupo',
  createGroup: 'Crear Grupo',
  saving: 'Guardando…',
  save: 'Guardar',
  members: 'Miembros',
  details: 'Detalles',
  you: 'Tu',
  name: 'Nombre',
  description: 'Description ',
  descriptionPlaceholder: 'Agregar descripción de grupo ',
  deleteGroup: 'Eliminar Group',
  deleteGroupConfirmation: 'Eliminar grupo?',
  leaveGroup: 'Salir del grupo',
  leaveGroupConfirmation: '¿Abandonar el grupo?',
  leaveGroupConfirmationDescription:
    '¿Estás seguro de que quiere dejar este grupo?',
  leaveGroupConfirmationAdminDescription:
    'Usted es uno de los administradores de este grupo. ¿Está seguro de que quiere dejarlo?',
  cannotLeaveGroup: 'No se puede abandonar el grupo',
  deleting: 'Eliminando…',
  add: 'Agregar',
  removeMember: 'Eliminar Miembro',
  removeMemberConfirm: 'Eliminar miembro?',
  sendDirectMessage: 'Enviar Mensaje',
  send: 'Enviar',
  sendVerificationCode: 'Enviar Código de Verificación',
  copyMessage: 'Copiar',
  chooseRecipient: 'Elegir Destinatario',
  loading: 'Cargando…',
  loadingMore: 'Cargando mas..',
  readBy: 'Leído por…',
  readBySummary: 'Leído por {{current}} de {{total}}',
  noReaders: 'Sin lectores',
  noResults: 'No hay resultados.',
  noNotifications: 'No hay notificaciones.',
  noCrew: 'No hay empleados.',
  createShiftErrorTitle: 'No se pudo crear el turno',
  editShiftErrorTitle: 'No se pudo modificar el turno',
  editTimeOffErrorTitle: 'No se pudo editar la solicitud de tiempo libre',
  cancelShiftErrorTitle: 'No se pudo cancelar el turno',
  swapShiftErrorTitle: 'No se pudo cambiar de turno',
  assignShiftErrorTitle: 'No se pudo asignar el turno',
  shiftActionErrorTitle: 'No se pudo realizar la acción de cambio',
  callOutCoverActionErrorTitle: 'No se pudo asignar la cobertura de llamada',
  callOutDetails: 'DETALLES DE LA LLAMADA',
  coverCallOut: 'CUBRIR LLAMADA',
  changeAmount: 'Cambiar Monto',
  changeIncentiveAmount: 'Cambie el monto del incentivo para este NEXT turno.',
  currentIncentiveAmount: 'MONTO ACTUAL DEL INCENTIVO',
  increaseBonus: 'Aumente la cantidad presionando "+".',
  decreaseBonus: 'Disminuya la cantidad presionando "-".',
  incrementBonusError:
    'La cantidad máxima de bonificación crítica para este turno es ${{maxAmount}}',
  decrementBonusError:
    'El monto mínimo de la bonificación crítica para este turno es ${{minAmount}}',

  changeIncentive: 'CAMBIAR CANTIDAD DE INCENTIVO A',
  confirmChangedAmount: 'Confirmar Cantidad Modificada',
  error: 'Error',
  date: 'Fecha',
  startTime: 'Hora de Inicio',
  endTime: 'Hora de Salida',
  helpdesk: 'Soporte técnico',
  noteToManager: 'Nota para el manager',
  requestNote: 'Nota de solicitud',
  noShiftsNoSwap: 'No hay turnos, por lo que el cambio no es posible',
  selectDifferentCrew: 'Selecciona una persona diferente',
  crewAvailable: 'EMPLEADOS DISPONIBLES PARA TOMAR EL TURNO',
  whoIsCanceling: '¿QUIÉN ESTÁ CANCELANDO ESTE TURNO?',
  cancellation: 'Cancelación',
  crewCanceled:
    'Esto se reflejará  en el historial de cancelación del empleado',
  crewCancelReason:
    '[OBLIGATORIO] Ingrese la razón por la que esta persona está cancelando. Tenga en cuenta que esto solo se comparte con sus co-gerentes y NO es visible para los empleados',
  onboard: 'Finalizar Registracion',
  welcomeToNext: 'Bienvenido a NEXT',
  enterYourPhoneNumberForVerification:
    'Ingrese su número de teléfono móvil a continuación, seleccione texto o llamada telefónica y luego presione el botón Enviar Código de Verificación.',
  verificationSMSFees:
    'Le enviaremos un código de verificación mediante un mensaje de texto o llamándole al número introducido anteriormente. Cargos extras pueden aplicar.',
  whatsYourPhoneNumber: '¿Cual es tu número de teléfono móvil?',
  mobileNumber: 'Número de teléfono móvil',
  signUpAgreement: 'Al registrarte, aceptas los',
  qrCodeDescription:
    'Alternativamente, inicie sesión en NEXT Web escaneando el QR desde la aplicación móvil. Vaya a Herramientas -> Escanear código QR de inicio de sesión.',
  termsOfService: 'Términos de Servicio',
  verifying: 'Verificando...',
  activating: 'Activando...',
  onboarding: 'Registrando...',
  enterTheVerificationCode:
    'Ingresa el código de verificación recibido en el número de teléfono:',
  whatsTheVerificationCode: `¿Cuál es el código de verificación?`,
  verificationCode: 'Código de  verificación',
  continue: 'Continuar',
  signIn: 'Iniciar sesión',
  hello: 'Hola!',
  onboardMessage:
    'Para completar el proceso de registración ingresa información solicitada a continuación.',
  enterFirstAndLastName: 'Tu nombre y apellido',
  firstAndLastName: 'Nombre y apellido',
  enterMonthDateOfBirth: 'Mes y día de nacimiento',
  enterStorePhoneNumber: 'El número de teléfono de tu tienda',
  storePhoneNumber: 'Número de teléfono de la tienda',
  enterYourPhoneNumber: 'Ingrese el número de teléfono móvil nuevamente',
  phoneNumber: 'Número de teléfono móvil',
  finish: 'Terminar',
  onboardingHelperMessage:
    'Si tienes algún problema para registrarte, envíanos un correo electrónico a:',
  invalidPhoneNumber: 'Numero de telefono no válido',
  invalidStorePhoneNumber: 'Número de teléfono de la tienda no válido',
  timeOffRequestExplanation:
    'Cuando no esté disponible, solicite días libres de su agenda semanal a través de la aplicación NEXT.<br/><ul><li>Si está solicitando tiempo libre <i>remunerado</i>, la solicitud debe realizarse utilizando su aplicación de recursos humanos/nómina.</li><li>Las solicitudes se revisarán y atenderán siempre que sea posible, pero no están garantizadas.</li></ul>',
  timeOffRequestAttestation:
    'Mi solicitud cumple con las políticas de tiempo libre de mi empresa',
  cancelRequest: 'Cancelar petición',
  submitRequest: 'Enviar solicitud',
  shiftBonus: 'Turno con Bonus',
  bonus: 'Bonus',
  seeNextShifts: 'Ver NEXT Shifts',
  seeNextShiftsOn: {
    one: 'Ver 1 NEXT Shift en %{date}',
    other: 'Ver %{count} turnos PRÓXIMOS en %{date}',
  },
  seeNextShiftsMatching: {
    one: 'Ver 1 NEXT Coincidencia de turnos',
    other: 'Ver coincidencia de %{count} NEXT Shifts',
  },
  seeNextShiftsWithIncentives: {
    one: 'Ver 1 NEXT Shift con incentivos',
    other: 'Ver %{count} NEXT Shifts con incentivos',
  },
  noScheduledShifts: 'No hay Turnos Programados.',
  pickUpNextShifts: '¿Toma NEXT Shifts?',
  userList: 'Lista de Usuarios',
  shiftPositionPrompt: '¿Qué ayuda necesita?',
  shiftReasonPrompt: '¿Por que?',
  shiftDateTimePrompt: '¿Cuando?',
  position: 'Posición',
  reason: 'Razón',
  welcomeTextList: [
    'Hola {FIRST_NAME}',
    'Hola {FIRST_NAME}',
    'Bienvenido {FIRST_NAME}',
    'Buenas, {FIRST_NAME}',
    'Buen día, {FIRST_NAME}',
    'Que tengas un buen {DAY_NAME}, {FIRST_NAME}',
    'Feliz {DAY_NAME}, {FIRST_NAME}',
  ],
  pendingMessage: ` 'Bienvenido a NEXT!

  Necesitamos más información para agregarte a tu tienda principal.

  Para completar la verificación, envía tu nombre, número de teléfono móvil, y número de teléfono de la tienda a esta dirección de correo electrónico:

  onboarding@nextforce.us`,
  workedShift: 'Turno Trabajado',
  didNotWorkShift: 'Datos de registro de tiempo no disponible',
  support: 'Soporte',
  chooseStore: 'Elegir una tienda...',
  back: 'Atrás',
  summaryNotAvailable: 'Resumen no disponible',
  see: 'Ver',
  shiftsWithAlerts: 'Turnos con alertas',
  customFilter: 'Filtrar...',
  filter: 'Filtrar',
  filtered: 'Filtrado',
  apply: 'Aplicar',
  reset: 'Reiniciar',
  positions: 'Posiciones',
  criticalShifts: 'Cambios críticos',
  shiftsWithMinor: 'Turnos con menor',
  shiftsWithInterest: 'Turnos con interes',
  nextShifts: 'Próximos turnos',
  nextShiftsMatchingPreset: 'NEXT Shifts que coinciden con el preajuste',
  nextShiftsMatching: 'NEXT Shifts coincidieron',
  nextShiftsWithIncentives: 'NEXT Shifts con incentivos',
  allNextShifts: 'Todos NEXT Shifts',
  nextShiftsWithIncentivesMoreThan10Dollars:
    'NEXT Shifts con incentivos de $10 o más',
  nextShiftsWithIncentivesMoreThan20Dollars:
    'NEXT Shifts con incentivos de $20 o más',
  nextShiftsWithoutIncentives: 'NEXT Shifts sin incentivos',
  breakfast: 'Desayuno (Hora de inicio 7am - 9am)',
  lunch: 'Almuerzo (Hora de inicio 11am - 2pm)',
  dinner: 'Cena (Hora de inicio 5pm - 7pm)',
  shiftsWithBonus: 'Turnos con bono',
  crewMembers: 'Miembros de la tripulación',
  all: 'Todos',
  none: 'Ninguno',
  allShifts: 'Todos los turnos',
  member: 'Miembro',
  alerts: 'Alertas',
  critical: 'Crítico',
  minor: 'Menor',
  interest: 'Interesar',
  rootedDeviceNotSupported: 'Rooted Devices No Soportado',
  thisWeek: 'Esta Semana',
  lastWeek: 'Semana Pasada',
  trend: 'Tendencia',
  shifts: 'Turnos',
  hrs: 'Horas',
  totals: 'Totales',
  crewScheduled: 'Empleados Programados',
  crewOnNext: 'Empleados en NEXT',
  shiftsScheduled: 'Turnos Programados',
  laborHours: 'Horas Laborales',
  otHours: 'Horas Extras',
  callOuts: 'Llamadas',
  seeWeeklySummary: 'Ver Resumen Semanal',
  gotIt: 'ENTENDIDO',
  myGroups: 'Mis Grupos',
  storeGroups: 'Grupos de Tiendas',
  showWeeklySummary: 'Ver Resumen Semanal',
  closeWeeklySummary: 'Cerrar Resumen Semanal',
  notFound: 'No Encontrado',
  searchMessages: 'Búsqueda de mensajes',
  searchShowingResultsFromDays:
    'Mostrando resultados de los últimos {{count}} días',
  loadEarlierMessages: 'Cargar Mensajes Anteriores',
  connectionError: 'No conectado a la red',
  noInternetScheduleScreenMessage:
    'Puedes ver tu horario actual, pero no se actualizará hasta que te vuelvas a conectar.',
  newMessage: 'Nuevo Mensaje',
  message: 'Mensaje',
  myOpenShifts: 'Mis NEXT Shifts',
  showSummaryTiles: 'Mostrar resumenes de eventos',
  savedFilters: 'FILTROS GUARDADOS',
  saveFilter: 'Guardar Filtro',
  saveFilterText: 'Seleccione una ranura para guardar el filtro en',
  howMany: 'Cuántos',
  multipleShifts: {
    one: 'Agregar 1 NEXT Shift %{positionName}',
    other: 'Agregar %{count} NEXT Shifts %{positionName}',
  },
  multipleNotifications: 'Notificaciones múltiples',
  multipleNotificationsDesc:
    'You have %{count} new notifications. Please check your NEXT App',
  textMe: 'Envíame un mensaje',
  callMe: 'Llámame',
  splitShiftTitle: 'Dividido NEXT Shift',
  splitShiftMessage: `Los NEXT Shifts más cortos tienen más posibilidades de llenarse. Este NEXT Turno puede dividir en varios NEXT Turnos cortos y consecutivos.

  ¿Te gustaría dividir el turno?`,
  addAndAssign: 'Agregar & Asignar',
  assignShift: 'Asignar este turno a un empleado',
  assignToThisCrew: 'Asignar turno a este empleado',
  assignShiftPositionPrompt: 'Agregar Turno & Asignar a un empleado',
  refreshCounter: 'Se actualiza en %{count} segundos.',
  imageLibraryPermissionDeniedTitle:
    'No ha dado permiso para acceder a sus fotos y videos.',
  imageLibraryPermissionDeniedBody:
    'Vaya a Privacidad -> Fotos en la aplicación Configuración',
  cameraPermissionDeniedTitle: 'No ha dado permiso para acceder a la cámara.',
  cameraPermissionDeniedBody:
    'Vaya a Privacidad -> Cámara en la aplicación Configuración',
  syncToCalendar: 'Sincronizar con el calendario del teléfono',
  calendarPermissionDeniedTitle: 'Administrar configuraciones',
  calendarPermissionDeniedBody:
    'Vaya a la configuración de la aplicación y permita el permiso del calendario',
  addShiftsToCalendar:
    'Agregar turnos programados al calendario de su teléfono?',
  yes: 'Sí',
  no: 'No',
  notNow: 'Ahora no',
  calendarSyncAlert:
    'Puede habilitar la configuración de sincronización del calendario yendo a la pantalla Configuración',
  devTools: 'Herramientas de desarrollo',
  downloadNextMessage:
    'Nuestra tienda utiliza NEXT para los horarios y la mensajería. Descargue NEXT para gerentes y empleado haciendo clic en bit.ly/NEXT-Android O bit.ly/NEXT-iOS. ',
  version: 'Versión',
  update: 'Actualización',
  sharingIsOffError:
    'No se puede asignar tripulación en la tienda seleccionada. La compartición está desactivada.',
  storeTooFarError:
    'No se puede asignar tripulación en la tienda seleccionada. La tienda está demasiado lejos',
  test: 'Prueba',
  apiEndpoint: 'API Endpoint',
  shareNext: 'Compartir NEXT',
  scanQr: 'Escanear código QR',
  scanQrDescription: 'Escanee el código QR para iniciar sesión en la NEXT web.',
  shareNextWithCoworkers: 'Comparte NEXT con tus compañeros de trabajo',
  submit: 'Enviar',
  crewRatingTitle: '¿Cómo estuvo el turno de {{name}}?',
  crewRatingDescription:
    '{{name}} completó este turno el {{date}} a las {{time}}',
  storeRatingTitle: '¿Cómo estuvo tu turno en {{store}}',
  storeRatingDescription: 'Completaste este turno el {{date}} a las {{time}}',
  badShiftReview: 'TUVE UN MAL TURNO',
  okayShiftReview: 'ESTUVO BIEN',
  goodShiftReview: 'ESTUVO BIEN',
  greatShiftReview: 'FUE GRANDIOSO!',
  sharingErrorMessage: 'Tu dispositivo no permite compartir',
  sharingErrorName: 'Error al compartir',
  sharingNotAvailable: 'Compartir no disponible',
  rateStore: 'Rate Tiendas',
  rateShifts: 'Rate reciente NEXT Shifts',
  rateShift: 'Rate Turno',
  noShiftsToRate: 'No turnos a rate',
  markAllNotificationsReadError:
    'Error al marcar todas las notificaciones como leídas',
  managersAndAbove: 'Gerentes y Superiores',
  managementTeam: 'Administración',
  teamMember: 'Miembro del Equipo',
  createEvent: 'Crear Evento',
  editEvent: 'Editar Evento',
  addNewEvent: 'Agregar Nuevo Evento',
  eventTitle: '*Título del Evento',
  eventDescription: '*Descripción del evento. Máximo 280 caracteres',
  addCustomEventErrorTitle: 'No se pudo crear evento.',
  editCustomEventErrorTitle: 'No se pudo modificar evento.',
  editUsernameErrorTitle: 'Error al editar el nombre de usuario',
  allStoreVisibilityText: {
    zero: 'Todos',
    one: 'Tienda',
    other: 'Todos {{count}} tiendas seleccionadas',
  },
  storeSelectedText: {
    one: '1 tienda seleccionada',
    other: '{{count}} tiendas seleccionadas',
  },
  customEvent: 'Eventos',
  deleteEvent: 'Eliminar Evento',
  deleteEventErrorTitle: 'No se pudo eliminar evento',
  filtersHelpTitle: 'Ayuda usando filtros',
  filtersExplanationMessage: `Selecciona los turnos NEXT que prefieras mediante filtros para tiendas, posición, incentivos y horarios de inicio. Una vez que hayas configurado los filtros, pulsa el botón "Aplicar" para ver los turnos NEXT que coinciden.

  Guarda tres filtros diferentes pulsando el botón "Guardar" y luego pulsando el botón 1, 2 o 3.

  Luego, puedes pulsar el botón 1, 2 o 3 y el botón "Aplicar" para ver los turnos NEXT filtrados.

  Tus selecciones de filtros guardados se mostrarán en la ficha "Mis turnos NEXT" de tu página de inicio para mayor comodidad.`,
  choosePhoto: 'Elegir foto',
  uploadPhotoModalText: 'Te gustaría subir una foto de perfil?',
  uploadPhotoAlert:
    'Puedes subir una foto de perfil en cualquier momento tocando el ícono de Cuenta en la esquina superior derecha de la barra de herramientas y luego tocando el espacio reservado para la foto.',
  uploadPhotoAlertTitle: 'Carga una foto de perfil',
  removePhotoTitle: 'Eliminar foto de perfil',
  removePhotoText: '¿Estás seguro de que quieres eliminar tu foto de perfil?',
  readOnly: 'Solo Lectura',
  crew: 'Empleados',
  managers: 'Gerentes',
  reminders: 'Recordatorios',
  birthdayWorkAnniversaryAndNewHire: 'Contratación, aniversarios y cumpleaños',
  coverRequestMessageTitle:
    'Compartir un mensaje en el grupo de toda la empresa sobre por qué necesitas que te cubran tu turno puede motivar a los compañeros a echar una mano',
  messagePlaceholder: 'escribe tu mensaje',
  anytimeMetrics: 'Métricas de tripulación en cualquier momento',
  metricsCaluculatedOverLastFourWeeks:
    'Métricas calculadas durante las últimas cuatro semanas',
  NEXTShiftsWorkedOverLastFourWeeks:
    'NEXT Turnos trabajados durante las últimas 4 semanas',
  NEXTShiftRating: 'PRÓXIMA Calificación del turno (número de calificaciones)',
  notActiveUser: 'Usuario no activo',
  occasionalUser: 'Usuario ocasional',
  regularUser: 'Usuario regular',
  notActive: 'No activo',
  occasionalInterest: 'Interés ocasional',
  regularIntest: 'Interés regular',
  crewMetricsLearnMore:
    'Toca para obtener más información sobre las métricas de rendimiento de Any-time Crew',
  monthlyProgress: 'Mi Progreso Mensual',
  currentEstimate: 'Estimación Actual',
  actual: 'Actual',
  currentMonthTargetMetMessage: '¡Buen trabajo! Siguiendo para superar la meta',
  currentMonthTargetNotMetMessage: 'Recoger los turnos NEXT',
  priorMonthTargetMetMessage: 'Superó la Meta',
  priorMonthTargetNotMetMessage: 'No se cumplió con la meta',
  earningsRate: 'Tasa de ganancias ${{rate}}',
  monthlyProgressExplanationMessage:
    'NEXT ayuda a hacer un seguimiento de tu progreso hacia tu objetivo de ingresos mensuales. Puedes ajustar la meta de ingresos mensuales desde la pantalla Cuentas > Editar Mi Perfil y tocando esta ficha. También puedes cambiar tu tasa de pago utilizada para calcular el salario bruto desde la pantalla Cuentas > Editar Mi Perfil.',
  hours: 'horas',
  hour: 'hora',
  grossPay: 'Ganancias brutas',
  monthlyTarget: 'Objetivo Mensual',
  daysToGo: 'Faltan {{days}} días',
  monthlyEarningsDescriptionTitle: 'Ajustar Ganancias Mensuales y Tasa de Pago',
  visibility: 'Visibilidad',
  everyone: 'Todos',
  splitNextShiftFromCancelledShiftTitle: 'El turno NEXT se dividirá',
  splitNextShiftFromCancelledShiftMessage:
    'Los NEXT Shifts más cortos tienen más posibilidades de llenarse. Este turno NEXT se dividirá en varios turnos NEXT Shifts consecutivos.',
  composeMessageDescriptionText:
    'Envía el mismo mensaje a múltiples grupos y/o individuos agregando los nombres en el campo Para:',
  callOutCoverageScreenTitle: 'Cobertura Inteligente de Llamadas',
  crossStoreClockInOut: 'reloj de entrada/salida de tiendas cruzadas >',
  uploadProfilePhotoError: 'Error uploading profile photo',
  storePreferences: 'Preferencias de la tienda',
  conversationDeleted: 'Conversación eliminada',
  conversationDeletedDescription: 'Esta conversación ha sido eliminada.',
  noMessages: 'No hay mensajes.',
  noPinnedMessages: 'No hay mensajes anclados.',
  filteredMembers: 'Miembros filtrados',
  filteredStores: 'Tiendas filtradas',
  call: 'Llamar',
  edit: 'Editar',
  remove: 'Eliminar',
  addRemove: 'Anadir/Remover',
  search: 'Buscar',
  addTeamMember: 'Anadir Miembro',
  editTeamMember: 'Editar Miembros',
  firstName: 'Primer Nombre',
  lastName: 'Segundo Nombre',
  select: 'Seleccionar',
  chooseStores: 'Elegir Tiendas',
  choose: 'Elegir',
  enterUserPhoneNumber:
    'Ingresa el número de telefón del usuario que quieres agregar a la gestión de turnos, luego presiona "Siguiente" para continuar.',
  enterMobileNumber: 'Ingresa el número de celular',
  addUserInfoText:
    'Completa el proceso ingresando la información solicitada a continuación.',
  inviteToNext: 'Invitar a NEXT',
  inviteToNextDescription: 'Envía un SMS al usuario para descargar el NEXT App',
  atLeastOneStoreRequired: 'Se requiere al menos una tienda.',
  selectedStores: 'Tiendas Seleccionadas',
  deleteUserErrorTitle: 'No se pudo eliminar el usuario',
  confirmDeleteUserTitle: 'Eliminar',
  confirmDeleteUserMessage:
    '¿Estás seguro de que quieres eliminar este usuario?',
  confirmDeleteObserverTitle: 'Quitar Del Equipo',
  confirmDeleteObserverMessage:
    '¿Está seguro de que desea quitar a este usuario del equipo de administración?',
  deleteObserverErrorTitle:
    'No se pudo quitar al usuario del equipo de administración.',
  delete: 'Borrar',
  confirmDeleteItem: '¿Estás seguro de que quieres eliminar este elemento?',
  recentChanges: 'Cambios Recientes',
  retry: 'Rever',
  showErrors: 'Mostrar errores',
  hideErrors: 'Ocultar errores',
  localeConfirm:
    'Se ha cambiado la configuración regional. ¿Cambiar a una nueva configuración regional?',
  edited: 'Editado',
  added: 'Anadido',
  changed: 'Cambiado',
  removed: 'Removido',
  toTheManagementTeam: 'para el equipo de gestión',
  fromTheManagementTeam: 'del equipo de gestión',
  loadingAccount: 'Cargando información de la cuenta',
  loadingUser: 'Cargando usuario',
  loadingStores: 'Cargando tiendas',
  loadingNotifications: 'Cargando notificaciones',
  loadingMessages: 'Cargando mensajes',
  loadingHomeScreen: 'Cargando pantalla de inicio',
  loadingData: 'Cargando datos',
  errorModalTitle:
    'Algunas funcionalidades pueden no funcionar correctamente. Presione el botón para recargar la aplicación.',
  uploadInProgressDescription:
    'Por favor, no cierre la aplicación hasta que se complete la carga...',
  sendMessageError: 'Error al enviar mensaje',
  media: 'Medios',
  documents: 'Documentos',
  mediaFiles: 'Archivos multimedia',
  pinnedMediaFiles: 'Archivos multimedia anclados',
  linkPreviewError: 'Error al obtener la vista previa del enlace',
  conversations: 'Conversaciones',
  allConversations: 'Conversaciones',
  allStores: 'Todas las tiendas',
  guestTeam: 'Invitados',
  management: 'Gestión',
  staffTeam: 'Personal',
  noMembers: 'No hay miembros',
  invalidAuthCode: 'Código de autorización inválido',
  qrCodeExpiredRegenerating: 'El código QR expiró. Regenerando...',
  teamMemberUpdated: 'Miembro del equipo actualizado',
  teamMemberUpdatedDescription:
    '{{name}} se ha actualizado en el equipo {{teamName}}',
  teamMemberAdded: 'Miembro del equipo agregado',
  teamMemberAddedDescription: '{{name}} ha sido añadido al equipo {{teamName}}',
  teamMemberDeleted: 'Miembro del equipo eliminado',
  teamMemberDeletedDescription:
    '{{name}} has been removed from the {{teamName}} Team',
  teamMemberUpdateErrorTitle: 'Error al actualizar a un miembro del equipo',
  teamMemberAddErrorTitle: 'Error al agregar un miembro del equipo',
  teamMemberDeleteErrorTitle: 'Error al eliminar un miembro del equipo',
  noToolsAvailable: 'No hay herramientas disponibles',
  companyNameJobTitle: 'Nombre de la empresa / Cargo',
  alreadyAMember: 'Ya eres miembro.',
  userBeingAddedTitle: 'Se está agregando un usuario',
  userBeingAddedDescription:
    'Se está agregando un usuario al equipo de administración. Espere a que se complete el proceso.',
  dropFilesHere: 'Suelta los archivos aquí',
  deleteMessage: 'Eliminar mensaje',
  deleteMessageConfirmation:
    '¿Estás seguro de que quieres eliminar este mensaje?',
  reasonForTimeOff: 'Motivo del tiempo libre',
  noRecentChanges: 'No hay cambios recientes',
  noStoresFound: 'No se encontraron tiendas',
  noMembersFound: 'No se encontraron miembros',
  guest: 'Invitado',
  staff: 'Personal',
  blockRtoCustomEventText:
    'No permitir solicitudes de tiempo libre durante este evento',
  editHolidayEventTitle: 'Editar evento de vacaciones',
  editHolidayEventErrorTitle: 'No se pudo editar el evento de vacaciones',
  editHolidayEventHeading:
    'Prohibir solicitudes de tiempo libre para este feriado',
  editHolidayEventDescription:
    'No se permitirán solicitudes de tiempo libre en este evento festivo para tiendas seleccionadas',
  accessDenied: 'Acceso denegado',
  navigationAccessDeniedMessage:
    'No tiene permiso para acceder a esta pantalla.',
  recentFiles: 'Archivos recientes',
  chatGroupMedia: 'Medios de chat de grupo',
  images: 'Imágenes',
  videos: 'Videos',
  pdfs: 'PDFs',
  otherFiles: 'Otros archivos',
  fileFolderSearch: 'Búsqueda de archivos y carpetas',
  filesGroupDescription:
    'Un grupo que se utiliza para compartir exclusivamente archivos y carpetas. Solo los administradores pueden crear y administrar carpetas y archivos. Los miembros pueden ver archivos. No se permiten mensajes en este grupo.',
  pinned: 'Fijado',
  attached: 'Adjunto',
  editFile: 'Editar archivo',
  editFolder: 'Editar carpeta',
  noFiles: 'No hay archivos',
  viewAll: 'Ver todo',
  filesGroup: 'Archivos compartidos',
  externalUrl: 'URL externa',

  createdBy: 'Creado por',
  uploadedBy: 'Subido por',
  noFilesOrFoldersFound: 'No se encontraron archivos ni carpetas',
  loadingRepositoryText:
    'Actualización del directorio del repositorio. Puede que tarde unos minutos.',
  addFile: 'Agregar archivo',
  addFolder: 'Agregar carpeta',
  pasteHere: 'Pegar aquí',
  today: 'Hoy',
  lastMonth: 'Mes pasado',
  thisMonth: 'Este mes',
  type: 'Tipo',
  externalFile: 'Archivo externo',
  unknown: 'Desconocido',
  openFile: 'Abrir archivo',
  chatGroupMediaFiles: 'Archivos multimedia del grupo de chat',
  noFilesFound: 'No se encontraron archivos',
  sortBy: 'Ordenar por',
  viewAs: 'Ver como',
  default: 'Por defecto',
  nameAsc: 'Nombre',
  dateAsc: 'Mayor',
  dateDesc: 'Nuevo',
  sizeDesc: 'Máximo',
  externalFileInfo:
    'Un archivo externo es un enlace a un archivo de terceros que no está almacenado en NEXT.',
  upload: 'Cargar',
  fileSize: 'Tamaño del archivo',
  path: 'Ruta',
  fileViewer: 'Visor de archivos',
  fileFolderActionErrorTitle: 'No se pudo realizar la acción de recurso',
  fileFolderActionCrossGroupErrorDescription:
    'No se pueden mover/copiar recursos entre diferentes grupos de chat.',
  loadingRecipientsText:
    'La carga puede tardar unos minutos, ya que el directorio de usuario se procesa por primera vez.',
  pendingTimeOffRequestsOverlapWithBlackoutDatesText:
    'La solicitud se superpone con las fechas restringidas recientemente agregada(s).',
  loadingChat: 'Cargando Chat',
  loadingChatText:
    'Procesando mensajes por primera vez. Esto puede llevar un tiempo.',
  loadingChatProgress: 'Mensajes procesados {{current}} de {{total}}',
  messageDeletedBy: 'Mensaje eliminado por {{name}}',
  youDeletedThisMessage: 'Has eliminado este mensaje',
  downloadingChat: 'Descargar mensajes de chat',
  loadingMemberProgress: 'Miembros procesados {{current}} de {{total}}',
  loadingMembers: 'Cargando miembros',
  downloadingMembers: 'Descargando miembros',
  copyHere: 'Copiar aquí',
  moveHere: 'Mover aquí',
  addUrl: 'Agregar URL',
  addLink: 'Agregar enlace',
  title: 'Título',
  selectFile: 'Seleccionar archivo',
  selectPhotoVideo: 'Seleccionar foto/video',
  webDocument: 'Documento web',
  files: 'Archivos',
  folders: 'Carpetas',
  grid: 'Cuadrícula',
  list: 'Lista',
  timeline: 'Línea de tiempo',
  shared: 'Compartido',
  openWebLink: 'Abrir enlace web',
  summary: 'Resumen',
  disallowRto: 'Denegar solicitud de permiso',
  madeEditText: {
    one: '{{name}} hizo una edición',
    other: '{{name}} hiza ediciones',
  },
  eventCreatedBy: 'Evento creado por {{name}} el {{date}}',
  changeHistory: 'Historial de cambios',
  availability: 'Disponibilidad',
  requestNonAvailability: 'Solicitar disponibilidad',
  requestNonAvailabilityExplanation:
    'Actualmente estás disponible para ser programado en todo momento. Puedes enviar una solicitud a tu gerente para cambiar tu disponibilidad. Toca los horarios en los que no puedes trabajar y luego envía tu solicitud.',
  requestNonAvailabilityPendingMessage:
    'Solicitud en espera de aprobación del gerente.',
  requestNonAvailabilityApprovedMessage:
    'Estás disponible para ser programado durante los horarios que se muestran en blanco. Puedes enviar una solicitud a tu gerente para cambiar tu disponibilidad. Toca un recuadro para cambiar o revertir, de disponible (blanco) a gris (no disponible) y luego envía tu solicitud.',
  availabilityChangeRequest: 'Solicitud de disponibilidad',
  seeRequest: 'Ver solicitud',
  availabilityDetails: 'Detalles de disponibilidad',
  noAvailabilities: 'No disponibilidad',
  addAvailabilityErrorTitle: 'No se pudo agregar disponibilidad',
  couldNotApproveRejectAvailabilityRequestErrorTitle:
    'No se pudo aprobar/rechazar la solicitud de disponibilidad',
  enterDescription: 'Ingrese una descripción',
  videoError: 'No se puede reproducir este video',
  expired: 'Expirado',
  requiresSign: 'Requiere firma',
  requiresAck: 'Requiere confirmación',
  overdue: 'Vencido',
  dueIn: 'Vence en',
  signed: 'Firmado',
  acknowledged: 'Confirmado',
  openAndSign: 'Abrir y Firmar',
  openAndAck: 'Abrir y Confirmar',
  defaultFileAckStatement:
    'Reconozco que he revisado el recurso proporcionado y comprendo su contenido, incluidas las políticas, procedimientos o expectativas descritos.',
  resourceHasNoAckRequests:
    'Este recurso no tiene solicitudes de confirmación.',
  requireSignInstructions:
    'Toque el archivo de arriba para abrir, luego haga clic en la casilla de verificación a continuación y escriba su nombre, luego toque el botón de firmar a continuación para completar.',
  requireAckInstructions:
    'Toque el archivo de arriba para abrir, luego haga clic en la casilla de verificación de abajo, luego toque el botón de confirmación de abajo para completar.',
  typeNameHere: 'Escribe tu nombre aquí',
  sign: 'Firmar',
  acknowledge: 'Confirmar',
  share: 'Compartir',
  setDueDate: 'Establecer fecha de vencimiento',
  dueDate: 'Fecha de vencimiento',
  receiptConfirmation: 'Confirmación de recibo',
  editStatementForRecipient: 'Editar declaración para el destinatario',
  typeAMessage: 'Escribe un mensaje ...',
  chooseRecipients: 'Elegir destinatarios',
  errorLoadingDetails: 'Error al cargar detalles',
  view: 'Ver',
  copy: 'Copiar',
  move: 'Mover',
  resourceAccessDenied: 'No tiene permiso para acceder a este recurso',
  acknowledgements: 'Confirmaciones',
  webLinks: 'Enlaces web',
  photosVideos: 'Fotos y videos',
  performanceReports: 'Informes de rendimiento',
  teamInsightsReport: 'Informe de rendimiento de equipo',
  storeInsightsReport: 'Informe de rendimiento de tienda',
  selectYear: 'Seleccionar año',
  unavailable: 'No disponible',
  year: 'Año',
  noCompanySelected: 'No hay empresa seleccionada',
  goldStar: 'Estrella de oro',
  awarding: 'Premiar',
  award: 'Premiar',
  awardGoldStars: 'Premiar estrellas de oro',
  transferGoldStars: 'Transferir estrellas de oro',
  transfer: 'Transferir',
  transferring: 'transfiriendo',
  transferSuccessful: 'Transferencia exitosa',
  transferSuccessfulDescription:
    'El destinatario ha recibido las estrellas de oro, y su saldo se ha reducido en {{starCount}} estrellas de oro.',
  errorGoldStarAlert: 'Error {{type}} estrellas de oro',
  sendMessageToCompanyGroup: 'suministro de noticias de la empresa',
  sendMessageToRecepientsStoreGroups:
    'El grupo de tiendas de cada destinatario',
  optionalMessage: 'Mensaje (Opcional)',
  enterTheNumberOfGoldStarsToTransfer:
    'Ingrese el número de estrellas de oro a transferir',
  goldStars: 'Estrellas de oro',
  goldStarsAvailable: 'Estrellas de oro disponibles',
  transactionLog: 'Registro de transacciones',

  insufficientGoldStars: 'Estrellas de oro insuficientes',
  insufficientGoldStarsDescription:
    'No tienes suficientes estrellas doradas para continuar. Actualmente tienes {{goldStars}} estrellas doradas disponibles',
  pickMembers: 'Elegir miembros',
  currentMonthStarAllocation:
    'Asignación de estrellas del mes actual: {{starCount}}',
  previousMonthStarBalance:
    'Estrellas doradas a finales del mes pasado: {{starCount}}',
  star: {
    one: 'estrella',
    other: 'estrellas',
  },
  goldStarTransaction: 'Registro de transacciones',
  awardStar: 'Premiar estrella',
  noChangesThisMonth: 'No hay cambios este mes',
  recipient: {
    one: 'Recipiente',
    other: 'Recipientes',
  },
  postToGroups: 'Publicar en grupos',
  dueToday: 'Vence Hoy',
  dueThisWeek: 'Vence Esta Semana',
  dueLater: 'Vence Después',
  completed: 'Completado',
  fileAcknowledgements: 'Confirmaciones de archivos',
  generateReport: 'Generar Informe',
  selectReportType: 'Seleccionar Tipo de Informe',
  yearToDate: 'Año hasta la Fecha',
  previousYear: 'Año Anterior',
  statement: 'Declaración',
  acknowledgedOn: 'Confirmado el',
  requestedBy: 'Solicitado por',
  requestedOn: 'Solicitado el',
  generatingReport: 'Generando Informe',
  reportGenerated: 'Informe Generado',
  confirmGeneration: 'Confirmar Generación',
  proceed: 'Proceder',
  dismiss: 'Cerrar',
  uploadedOn: 'Cargado el',
  transactionsReport: 'Reporte de Transacciones',
  generateReportText:
    'Los datos solicitados se enviarán a través de un mensaje directo desde nuestro backend y pueden tardar unos minutos en procesarse. Proceder?',
  reportIsBeingGenerated:
    'Su informe se está generando y se enviará a través de un mensaje directo.',
  reportGeneratedText:
    'Su informe ha sido generado. Por favor, verifique su mensaje directo para verlo.',
  alreadySent: 'Ya enviado',
  reply: 'Responder',
  unreadMessageCount: {
    one: '1 mensaje no leído',
    other: '{{count}} mensajes no leídos',
  },
  addedByNext: 'Agregado por NEXT',
  newMessagesCount: {
    one: '1 nuevo mensaje',
    other: '{{count}} nuevos mensajes',
  },
  addTask: 'Agregar Tarea',
  editTask: 'Editar Tarea',
  assignedTo: 'Asignado a',
  photoRequired: 'Requerido foto',
  recurring: 'Recurrente',
  until: 'Hasta',
  frequency: 'Frecuencia',
  interval: 'Intervalo',
  monthlyOn: 'Mensual el',
  onDay: 'En el día',
  byDay: 'Por día',
  tasks: 'Tareas',
  tasksCount: {
    one: '1 tarea',
    other: '{{count}} tareas',
  },
  taskDetails: 'Detalles de la tarea',
  createTask: 'Crear Tarea',
  addRecurrentTask: 'Agregar Tarea Recurrente',
  editRecurrentTask: 'Editar Tarea Recurrente',
  // Repeat text translations
  repeating: 'Repitiendo',
  every: 'cada',
  repeatDay: {
    one: 'día',
    other: 'días',
  },
  repeatWeek: {
    one: 'semana',
    other: 'semanas',
  },
  repeatMonth: {
    one: 'mes',
    other: 'meses',
  },
  repeatYear: {
    one: 'año',
    other: 'años',
  },
  repeatDayNames: {
    MO: 'Lun',
    TU: 'Mar',
    WE: 'Mié',
    TH: 'Jue',
    FR: 'Vie',
    SA: 'Sáb',
    SU: 'Dom',
  },
  repeatOn: 'el',
  repeatOnDay: 'el día',
  repeatUntil: 'hasta',
  taskPhotos: 'Fotos de la tarea',
  confirm: 'Confirmar',
  due: 'Vencimiento',
  open: 'Abrir',
  late: 'Tarde',
  noTasks: 'No Tareas',
  freqDays: 'Días',
  month: 'Mes',
  freqWeeks: 'Semanas',
  freqMonths: 'Meses',
  freqYears: 'Años',
  taskSummaryPlaceholder: 'Ingrese el título de la tarea',
  taskDescriptionPlaceholder: 'Ingrese la descripción de la tarea',
  assignTo: 'Asignar a',
  notAssigned: 'No Asignado',
  repeat: 'Repetir',
  never: 'Nunca',
  addTaskErrorTitle: 'No se pudo agregar tarea',
  editTaskErrorTitle: 'No se pudo editar tarea',
  status: 'Estado',
  dueOn: 'Vence en',
  photosRequiredLabel: 'Fotos (Requerido)',
  reassign: 'Reasignar',
  assign: 'Asignar',
  markAsDone: 'Marcar como hecho',
  deletingRecurringTaskTitle: 'Eliminando Tarea Repetida',
  deletingRecurringTaskDescription:
    'Por favor seleccione qué tareas repetidas eliminar',
  deleteTaskTitle: 'Eliminar Tarea',
  deleteTaskDescription: '¿Estás seguro de que quieres eliminar esta tarea?',
  errorDeletingTask: 'Error al eliminar tarea',
  errorMarkingTaskComplete: 'Error al marcar tarea como hecha',
  reassignTask: 'Reasignar Tarea',
  assignTask: 'Asignar Tarea',
  errorReassigningTask: 'Error reasignando tarea',
  noUsersReassignTaskNote:
    'No hay usuarios disponibles para reasignar la tarea.',
  noUsersAssignTaskNote: 'No hay usuarios disponibles para asignar la tarea.',
  this: 'Este',
  thisAndFollowing: 'Este y siguientes',
  setUpdateType: 'Establecer Tipo de Actualización',
  characterLimitExceeded: 'Mensaje demasiado largo',
  yourMessageExceedsTheCharacterLimit:
    'El mensaje supera el límite de caracteres {{limit}}. Por favor, acortarlo o dividirlo en varios mensajes.',
  urgentToggleText:
    'Urgente. Notificar a todos los destinatarios por mensaje de texto.',
  urgentMessage: 'Urgente',
  urgentMessageConfirmationDescription:
    '¿Estás seguro de que quieres notificar a todos los destinatarios por mensaje de texto?',
  empty: 'vacío',
  selectCompany: 'Seleccionar empresa',
  selectCompanyDescription: `Seleccione la empresa cuyos miembros desea incluir en este grupo`,
  myEarnings: 'Mis ganancias',
  dailyPayHomeScreenTitle: 'Obtén tus ganancias después de cada turno',
  dailyPayHomeScreenBadge: '¡Nuevo!',
  dailyPayHomeScreenDescription:
    'Disfruta de la flexibilidad de acceder a tus ganancias en tiempo real. Empieza hoy mismo con la app de DailyPay.',
  allAdmins: 'Todos los Administradores',
  allObservers: 'Todos los Observadores',
  allManagers: 'Todos los Gerentes',
  allSeniorManagers: 'Todos los Gerentes Senior',
  allCrew: 'Todo el Personal',
  newHires: 'Nuevos Empleados',
  allStaff: 'Todo el Personal',
  allGuests: 'Todos los Invitados',
  memberAlias: {
    seniorManagers: 'Gerentes Senior',
    managers: 'Gerentes',
    staff: 'Personal',
    guests: 'Invitados',
    newHires: 'Nuevos Empleados',
    crew: 'Personal',
    admins: 'Administradores',
  },
  addedManually: 'Agregado manualmente',
  addedViaAllAdminsAlias:
    'Agregado mediante el alias Todos los Administradores',
  addedViaAllObserversAlias:
    'Agregado mediante el alias Todos los Observadores',
  addedViaAllManagersAlias: 'Agregado mediante el alias Todos los Gerentes',
  addedViaAllCrewAlias: 'Agregado mediante el alias Todo el Personal',
  addedViaAllStaffAlias: 'Agregado mediante el alias Todo el Personal',
  addedViaAllGuestsAlias: 'Agregado mediante el alias Todos los Invitados',
  addedViaNewHiresAlias: 'Agregado mediante el alias Nuevos Empleados',
  removeAliasConfirmationTitle: 'Eliminar {{alias}} alias',
  removeAliasConfirmationDescription:
    '¿Estás seguro de que quieres eliminar {{alias}} alias de este grupo?',
  activeAliases: 'Alias activos',
  otherMembers: 'Otros miembros',
  invalidUrl: 'Esta URL no se puede abrir en la aplicación.',
  webOnboardingNotSupported:
    'Los nuevos usuarios deben completar el registro en la aplicacion movil.',
}
